import { VideoAd } from "../models";
import { fetchAuthenticated } from "../scripts/custom-fetch";

export async function createVideoAd(video: Omit<VideoAd, "id" | "createdAt" | "updatedAt">) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/video-ads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(video),
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as VideoAd;
}

export async function updateVideoAd(videoId: number, video: Partial<Omit<VideoAd, "id" | "createdAt" | "updatedAt">>) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/video-ads/${videoId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(video),
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }
}

export async function getVideoAds() {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/video-ads`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as VideoAd[];
}

export async function getVideoAd(videoId: number) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/video-ads/${videoId}`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as VideoAd;
}